import React from 'react';
import PropTypes from 'prop-types';

// var VideoEntity = React.createClass({
//     displayName: 'VideoEntity',
//     mixins: [],
//     propTypes: {
//         entity: PropTypes.any
//     },
//     getInitialState: function () {
//         return {
//             isPlaying: false
//         };
//     },
//     playVideo: function () {
//         this.setState({ isPlaying: true });

//     },
//     render: function () {
//         //var entity = this.props.entity;
//         //return <div className='video-entity'>
//         //    <div className="preview ">
//         //        <img className="thumb" src={ entity.getMediaImageUrl() } />
//         //        <p className="text ellipsis-wrap">{ entity.title }</p>
//         //    </div>
//         //</div>;
//         var entity = this.props.entity;
//         var inner = null;
//         var className = 'video-entity';

//         if (this.state.isPlaying) {
//             var frameSrc = this.props.entity.get('embed').match(/src="(\S*)"/i)[1];
//             inner = (
//                 <div className="screen">
//                     <iframe src={frameSrc} width="100%" height="100%" className="embedly-embed" scrolling="no" frameBorder="0" allowFullFcreen />
//                 </div>
//             );
//             className += ' playing';
//         } else {
//             inner = (
//                 <div className="preview " onClick={this.playVideo}>
//                     <img className="thumb" src={entity.getMediaImageUrl()} />
//                     <p className="text ellipsis-wrap">{entity.title}</p>
//                 </div>
//             );
//         }

//         return (
//             <div ref="videoEntity" className={className}>
//                 {inner}
//             </div>
//         );
//     }
// });

class VideoEntity extends React.Component {
  static displayName = 'VideoEntity';

  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false
    };
  }

  playVideo() {
    this.setState({ isPlaying: true });
  }

  render() {
    //var entity = this.props.entity;
    //return <div className='video-entity'>
    //    <div className="preview ">
    //        <img className="thumb" src={ entity.getMediaImageUrl() } />
    //        <p className="text ellipsis-wrap">{ entity.title }</p>
    //    </div>
    //</div>;
    var entity = this.props.entity;
    var inner = null;
    var className = 'video-entity';

    if (this.state.isPlaying) {
      var frameSrc = this.props.entity.get('embed').match(/src="(\S*)"/i)[1];
      inner = (
        <div className="screen">
          <iframe
            src={frameSrc}
            width="100%"
            height="100%"
            className="embedly-embed"
            scrolling="no"
            frameBorder="0"
            allowFullFcreen
          />
        </div>
      );
      className += ' playing';
    } else {
      inner = (
        <div className="preview " onClick={this.playVideo}>
          <img className="thumb" src={entity.getMediaImageUrl()} />
          <p className="text ellipsis-wrap">{entity.title}</p>
        </div>
      );
    }

    return (
      <div ref="videoEntity" className={className}>
        {inner}
      </div>
    );
  }
}

export default VideoEntity;
